module.exports = __webpack_public_path__ + "img/menu-icon-news-feed.130bced9.svg";